export default {
  getUsername(state) {
    let username = '';
    if (state.session?.token)  {
      const b64ToJsonStr = str => window.atob(str);
      const payload = state.session.token.split('.')[1];
      ({ username } = JSON.parse(b64ToJsonStr(payload)));
    }
    return username;
  },
  getTiposPesd: state => state.tiposPesd,
};
